export const Breakpoints = {
  MEDIUM: 780,
  LARGE: 980,
  M_Large: 1200,
  X_LARGE: 1280,
};
